class AnimationSubsSingleTextImage {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleSubsSingleTextImage = this.sectionsContainer.querySelectorAll('.subs-single-text-image');
		
		if (!this.$moduleSubsSingleTextImage.length)
			return;
		
		this.$moduleSubsSingleTextImageElements = [];
		this.$moduleSubsSingleTextImage.forEach(module => {
			this.$moduleSubsSingleTextImageElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleSubsSingleTextImage.forEach((module, index) => {
		    console.log(this.$moduleSubsSingleTextImageElements[index])
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleSubsSingleTextImageElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		const moduleSubsSingleTextImage = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleSubsSingleTextImage[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleSubsSingleTextImageElements[index], { clearProps: true });
			}
        });

        moduleSubsSingleTextImage.addLabel('step1');
        moduleSubsSingleTextImage.to(this.$moduleSubsSingleTextImage[index], { opacity: 1, duration: 1 }, 'step1');
		moduleSubsSingleTextImage.to(this.$moduleSubsSingleTextImageElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationSubsSingleTextImage;
